export {
  default,
  getStaticProps,
} from 'containers/Accessibility/Accessibility';
